export default class NotFoundError extends Error implements Error {
    name = 'NotFoundError'

    constructor (message = 'Page not found') {
        super(message)
    }
}
